import * as React from "react";
import {cx} from "emotion";

import "./account-layout-route.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Responsive2}    from "@Common/ui-components/responsive-2";

import {SubHeader} from "../../../common/sub-header/sub-header";
import {Layout}    from "../../../layout/layout";

import {Menu}       from "./menu/menu";
import {MenuMobile} from "./menu/menu-mobile";

export const AccountLayout = (
    {
        active,
        overflow=false,
        activeTab=null,
        navBlock=null,
        next,
    }
) => cs(
    consumeContext("userLevels"),
    ({}, next) => Layout({
        active: "profile", //to-do: refactor to make this "account"
        className: "account-layout-2b6 root",
        navBlock,
        children: next(),
    }),
    ["viewMode", (_, next) => Responsive2({
        translate: (w) => w < 1024 ? "mobile" : "desktop",
        next,
    })],
    ["subHeader", (_, next) => next(SubHeader({
        backLink: {
            to: "/",
            label: "Home",
        },
        navBlock,
        title: TITLE_ACCOUNT_RESOURCES,
    }))],
    ({viewMode, userLevels, subHeader}) => (
        viewMode === "mobile" ? (
            MobileView({
                menu: MenuMobile({active, activeTab, userLevels, navBlock}),
                subHeader,
                next,
            })
        ) : (
            DesktopView({
                subHeader,
                overflow, active,
                navBlock,
                next,
            })
        )
    ),
);

const DesktopView = ({subHeader, overflow, active, navBlock, next}) => (
    <div className={cx("account-layout-2b6 desktop", {overflow})}>
        {subHeader}

        <div className="main">
            {Menu({active, navBlock})}
            <div className={"content"}>
                {next()}
            </div>         
        </div>           
    </div>
);

const MobileView = ({subHeader, menu, next}) => (
    <div className="account-layout-2b6 mobile">
        {subHeader}
        <div className="main">
            {menu}
            <div className={"content"}>
                {next()}
            </div>
        </div>       
    </div>
);

const TITLE_ACCOUNT_RESOURCES = "Account Resources & Programs";
